export const APP_VERSION = '0.0.43-alpha1';
export const DEFAULT_API_BASE_URL = '/api/v1';
export const DEFAULT_REMOTE_API_BASE_URL = '';

export function detectRuntime() {
  if (typeof window === 'undefined') return 'server';
  if (window.Capacitor?.isNativePlatform?.()) return 'android';
  if (navigator.userAgent.includes('Electron')) return 'electron';
  return 'web';
}

export function getRuntimeConfig() {
  const runtime = detectRuntime();
  const configured = globalThis.__DOPE_MAN_CONFIG__ ?? {};
  let apiBaseUrl = configured.apiBaseUrl ?? DEFAULT_API_BASE_URL;
  if ((runtime === 'electron' || runtime === 'android') && apiBaseUrl.startsWith('/')) {
    apiBaseUrl = configured.remoteApiBaseUrl ?? DEFAULT_REMOTE_API_BASE_URL;
    if (!apiBaseUrl) {
      throw new Error('A remote API URL is required for native/desktop runtime. Configure remoteApiBaseUrl in runtime-config.js.');
    }
  }
  return Object.freeze({
    appVersion: APP_VERSION,
    runtime,
    apiBaseUrl: apiBaseUrl.replace(/\/$/, ''),
    onlineEnabled: configured.onlineEnabled ?? true,
  });
}
